import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { DistributionSegment } from "../../store/metrics/state";
import { orderBy, find } from "lodash";
import { KpiService } from "../../kpi/kpi.service";

@Component({
  selector: "clickable-bar",
  templateUrl: "./clickable-bar.component.html",
  styleUrls: ["./clickable-bar.component.scss"],
})
export class ClickableBarComponent implements OnInit, OnChanges {
  @Input() data: Array<DistributionSegment>;
  @Input() column;
  @Output() selectedSegment = new EventEmitter();
  @Input() prefix;
  @Input() suffix;
  @Input() studentKpiId;
  @Input() overallSubtitle;
  @Input() last;
  selectedSeg: number;
  pseudoUpIsGood: boolean;

  constructor(public kpiService: KpiService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.data = orderBy(this.data, ["order"], ["asc"]);
      if (this.data && this.data.length > 1) {
        // we look at the last bar's performance level max - the first bar's performance level max to see if up is good or not
        // (we can't use the metric's upIsGood because it isn't stored for the student metric, and this causes weird issues for Attendance/Chronic Absence)
        this.pseudoUpIsGood =
          this.data[this.data.length - 1].performanceLevelMax -
            this.data[0].performanceLevelMax >
          0;
      }
    }
  }

  toggleSeg(seg) {
    if (this.selectedSeg != null && this.selectedSeg == seg.order) {
      this.selectedSeg = null; // toggle off
      this.selectedSegment.emit({
        data: null,
        column: this.column,
        numBars: this.data.length,
      });
    } else {
      this.selectedSeg = seg.order; // toggle on for this seg
      this.selectedSegment.emit({
        data: find(this.data, (item) => {
          return item.order == seg.order;
        }),
        column: this.column,
        numBars: this.data.length,
        pseudoUpIsGood: this.pseudoUpIsGood,
      });
      this.kpiService
        .trackOurStudentsDistChartClick(this.studentKpiId)
        .subscribe(
          (data) => {},
          (error) => {
            console.error(error);
          }
        );
    }
  }
}
